/**
 * @file constants.tsx
 * @description 打点常量定义
 * @author ares
 * @date 2026-05-26
 */

export const TrackEvents = {
    // 页面
    PAGE_HOME: 'home',
    // 剧本相关页面
    PAGE_SCRIPT_EDITOR: 'script_editor',
    PAGE_SCRIPT_DETAIL: 'script_detail',
    // 主体资产页面
    PAGE_SUBJECT_ASSET: 'subject_asset',
    // 分镜Agent页面
    PAGE_EPISODE_AGENT: 'storyboard',
    // 分镜表格页
    PAGE_STORYBOARD_TABLE: 'storyboard_table',
    // 会员等级弹窗页面
    PAGE_MEMBERSHIP_SUBSCRIPTION_POP: 'membership_subscription_pop',
    // 积分不足提示弹窗-页面
    PAGE_INSUFFICIENT_CREDITS_POP: 'insufficient_credits_pop',
    // 会员及积分服务协议页面
    PAGE_MEMBERSHIP_AGREEMENT: 'membership_subscription_payment_agreement',

    // 公共行为
    NETWORK_FAIL: 'network_fail',
    NETWORK_RETRY: 'network_retry',
    AGENT_CLOSE: 'agent_close',
    AGENT_BTN: 'agent_btn',
    // 画布页面
    PAGE_CANVAS: 'canvas',

    // 用户行为
    /** ------ 剧本相关用户行为 ------ */
    SCRIPT_EDITOR: 'script_editor',
    SCRIPT_DETAIL: 'script_detail',
    SCRIPT_ANALYZE: 'script_analyzing',
    SCRIPT_ANALYZE_FAIL_FORMAT_RETRY: 'script_analyze_fail_format_retry',
    SCRIPT_ANALYZE_FAIL_FORMAT_MANUAL: 'script_analyze_fail_format_manual',
    SCRIPT_UPLOAD_FAIL: 'script_upload_fail',
    SCRIPT_BACK: 'script_back',
    SCRIPT_WAITING: 'script_waiting',
    SCRIPT_OVERVIEW_TAB: 'script_overview_tab',
    SCRIPT_OVERVIEW: 'script_overview',
    SCRIPT_EPISODE_TAB: 'script_episode_tab',
    SCRIPT_EPISODE: 'script_episode',
    SCRIPT_DOWNLOAD: 'script_download',
    SCRIPT_EDIT: 'script_edit',
    SCRIPT_EDIT_EXIT: 'script_edit_exit',
    SCRIPT_OPTIMIZE: 'script_optimize',
    SCRIPT_REJECT: 'script_reject',
    SCRIPT_SUBMIT: 'script_submit',
    SCRIPT_CONFIRM: 'script_confirm',
    SCRIPT_AGENT_REGENERATE: 'script_agent_regenerate',
    SCRIPT_AGENT_COPY: 'script_agent_copy',

    /** ------ 主体资产相关行为 ------ */
    // 用户行为-资产页面级
    SUBJECT_ASSET_PAGE: 'subject_asset_page',
    SUBJECT_ASSET_TAB: 'subject_asset_tab',
    ASSET_GO_CANVAS_BTN: 'go_canvas_btn',

    // 用户行为-资产卡片
    ASSET_ADD_CARD: 'add_card',
    ASSET_DELETE_BTN: 'asset_delete_btn',
    ASSET_CREATE_BTN: 'asset_create_btn',
    ASSET_NAME_EDIT_BTN: 'asset_name_edit_btn',
    ASSET_PROMPT_EDIT_BTN: 'asset_prompt_edit_btn',
    ASSET_PROMPT_COPY_BTN: 'prompt_copy_btn',

    // 用户行为-资产角色相关
    ASSET_OUTFIT_CREATE_BTN: 'outfit_create_btn',
    ASSET_ADD_OUTFIT_BTN: 'add_outfit_btn',
    ASSET_DELETE_OUTFIT_BTN: 'delete_outfit_btn',
    ASSET_CHARACTER_BIO_EDIT_BTN: 'character_bio_edit_btn',
    ASSET_OUTFIT_PROMPT_EDIT_BTN: 'outfit_prompt_edit_btn',

    // 用户行为-资产出场集
    ASSET_EPISODE_COUNT: 'EpisodeCount',
    ASSET_EPISODE_COUNT_EDIT: 'EpisodeCount_edit',
    ASSET_EPISODE_COUNT_EDIT_CHECK: 'EpisodeCount_edit_check',
    ASSET_EPISODE_COUNT_EDIT_CANCEL: 'EpisodeCount_edit_cancel',

    // 用户行为-资产音色/语速
    ASSET_VOICE_SELECT_BTN: 'voice_select_btn',
    ASSET_VOICE_SPEED_BTN: 'voice_speed_btn',

    // 用户行为-资产智能提取
    ASSET_EXTRACT_BTN: 'extract_btn',
    ASSET_RE_EXTRACT_BTN: 're_extract_btn',
    ASSET_EXTRACT_SHOW: 'extract_show',
    ASSET_EXTRACT_CONFIRM_ADD: 'extract_confirm_add',
    ASSET_EXTRACT_DISCARD_ADD: 'extract_discard_add',

    /** ------ 用户行为-预览弹窗 ------ */
    PREVIEW_DIALOG: 'preview_dialog',
    PREVIEW_DIALOG_CLOSE: 'preview_dialog_close',
    PREVIEW_LIST_SWITCH: 'preview_list_switch',
    PREVIEW_THUMBNAIL_SWITCH: 'preview_thumbnail_switch',
    PREVIEW_REVIEW_LEVEL_SELECT: 'preview_review_level_select',
    PREVIEW_COMMENT_ICON_CLICK: 'preview_comment_icon_click',
    PREVIEW_CREATE_BTN: 'preview_create_btn',

    /** ------ 首页相关行为 ------ */
    HOME: 'home',
    PLATFORM_LOGO: 'platform_logo',
    FEATURE_CARD: 'feature_card',
    CASE_VIDEO: 'case_video',
    PROJECT_CARD: 'project_card',
    ALL_PROJECT_BTN: 'all_project_btn',
    HOT_CASE: 'hot_case',
    HOT_CASE_CARD: 'hot_case_card',
    CREATE_PROJECT_WINDOW: 'create_project_window',
    CREATE_PROJECT_WINDOW_CONFIRM_BTN: 'create_project_window_confirm_btn',

    /** ------ 侧边栏相关行为 ------ */
    CREDIT_TAB: 'credit_tab',
    USER_AVATAR: 'user_avatar',
    USER_INFO: 'user_info',
    ACCOUNT_SETTING: 'account_setting',
    LOGOUT: 'logout',
    LOGOUT_BTN: 'logout_btn',
    WECOME: 'wecome',
    PROTOCOL_MENU: 'protocol_menu',
    PLATFORM_PROTOCOL: 'platform_protocol',
    PRIVACY_PROTOCOL: 'privacy_protocol',
    MEMBER_ENTRY: 'member_entry',
    CREDIT_RECHARGE_ENTRY: 'credit_recharge_entry',
    USERINFO_CREDIT_DETAIL: 'userinfo_credit_detail',
    USERINFO_MEMBER_CENTER: 'userinfo_member_center',
    USERINFO_CREDIT_RECHARGE: 'userinfo_credit_recharge',
    USERINFO_SUBSCRIPTION_MANAGE: 'userinfo_subscription_manage',
    USERINFO_ORDER_RECORD: 'userinfo_order_record',
    USERINFO_CONTACT: 'userinfo_contact',

    /** ------ 积分详情弹窗相关行为 ------ */
    CREDIT_WINDOW: 'credit_window',
    CREDIT_WINDOW_SWITCH_BTN: 'credit_window_switch_btn',
    CREDIT_WINDOW_WITHDRAW_BTN: 'credit_window_withdraw_btn',
    CREDIT_WINDOW_MEMBER: 'credit_window_member',
    CREDIT_WINDOW_CREDIT: 'credit_window_credit',

    /** ------ 积分不足提示弹窗相关行为 ------ */
    INSUFFICIENT_CREDITS_POP: 'insufficient_credits_pop',
    POPUP_OPEN_MEMBERSHIP: 'popup_open_membership',
    POPUP_CREDIT_RECHARGE: 'popup_credit_recharge',

    /** ------ 画布资源面板 ------ */
    // 资源组创作按钮
    CANVAS_GO_CREATE_BTN: 'go_create_btn',
    // 资源面板展开/收起切换
    CANVAS_SIDE_PANEL_TOGGLE: 'side_panel_toggle',
    // 素材库打开
    MATERIAL_LIB_OPEN: 'material_lib_open',
    // 素材库置入画布
    MATERIAL_LIB_INSERT: 'material_lib_insert',
    // 素材库 hover 预览面板
    MATERIAL_HOVER_PANEL: 'material_hover_panel',
    // 素材库 hover 预览面板-播放点击
    MATERIAL_PLAY_BTN: 'material_play_btn',
    // 素材库 hover 预览面板-下载按钮
    MATERIAL_DOWNLOAD_BTN: 'material_download_btn',
    // 素材库面板-点击「添加」
    MATERIAL_PANEL_ADD: 'material_panel_add_btn',
    // 素材库面板-点击「取消」
    MATERIAL_PANEL_CANCEL: 'material_panel_cancel_btn',
    // 官方模板库打开
    TEMPLATE_LIB_OPEN: 'template_lib_open',
    // 官方模板置入画布
    TEMPLATE_APPLY: 'template_apply',
    // 官方模板 hover 预览面板
    TEMPLATE_HOVER_PANEL: 'template_hover_panel',
    // 官方模板 hover 预览面板-播放点击
    TEMPLATE_PLAY_BTN: 'template_play_btn',
    // 官方模板 hover 预览面板-下载按钮
    TEMPLATE_DOWNLOAD_BTN: 'template_download_btn',

    /** ------ 画布页行为 ------ */
    // 画布页展现
    CANVAS_PAGE: 'canvas_page',
    // 画布 shape 工具栏展现
    CANVAS_SHAPE_TOOLBAR: 'toolbar',
    // 下载
    MEDIA_DOWNLOAD: 'media_download',
    // 图片裁剪
    IMG_CROP: 'img_crop',
    // 图片确认裁剪
    IMG_CROP_CONFIRM: 'img_crop_confirm',
    // 提交面板打开
    SUBMIT_MATERIAL_PANEL_OPEN: 'submit_material_panel_open',
    // 提交选项列表选择
    SUBMIT_MATERIAL_PANEL_SELECT: 'submit_material_panel_select',
    // 提交选项智能匹配
    SMART_LOCAL_RESULT: 'smart_locate_result',
    // 提交成功
    MEDIA_SUBMIT_MATERIAL: 'media_submit_material',
    // 添加到对话
    MEDIA_ADD_TO_CHAT: 'media_add_to_chat',
    // 重新编辑
    MEDIA_RE_EDIT: 'media_re_edit',
    // 再次生成
    MEDIA_REGENERATE: 'media_regenerate',
    // 媒体生成信息
    MEDIA_GENERATE_INFO: 'media_generate_info',
    // 图片快捷改图
    IMG_QUICK_EDIT: 'img_quick_edit',
    // 图片多视图
    MULTIPLE_PERSPECTIVES: 'multiple_perspectives_btn',
    // 图片多视图二级菜单选择
    MULTIPLE_PERSPECTIVES_SEC: 'multiple_perspectives_sec_btn',
    // 图片宫格切分
    IMAGE_SEGMENTATION: 'segmentation_btn',
    // 图片宫格切分二级菜单选择
    IMAGE_SEGMENTATION_SEC: 'segmentation_sec_btn',
    // 图片超清
    IMG_UPSCALE: 'img_upscale',
    // 图片超清修改分辨率、修改细节生成程度
    IMG_UPSCALE_SETTING_CHANGE: 'img_upscale_setting_change',
    // 图片超清确认
    IMG_UPSCALE_CONFIRM: 'img_upscale_confirm',
    // 视频超清
    VIDEO_UPSCALE: 'video_upscale',
    // 视频超清修改分辨率、修改细节生成程度
    VIDEO_UPSCALE_SETTING_CHANGE: 'video_upscale_setting_change',
    // 视频超清确认
    VIDEO_UPSCALE_CONFIRM: 'video_upscale_confirm',
    // 视频对口型
    VIDEO_LIPSYNC: 'video_lipsync',
    // 对口型-音频来源选择
    VIDEO_LIPSYNC_AUDIO_SOURCE_SELECT: 'video_lipsync_audio_source_select',
    // 对口型-确认生成
    VIDEO_LIPSYNC_CONFIRM: 'video_lipsync_confirm',
    // 音频修改台词
    AUDIO_EDIT_SCRIPT: 'audio_edit_script',
    // 音频修改台词取消
    AUDIO_EDIT_SCRIPT_CANCEL: 'audio_edit_script_cancel',
    // 音频修改台词确认
    AUDIO_EDIT_SCRIPT_CONFIRM: 'audio_edit_script_confirm',
    // 组工具栏自动布局
    GROUP_AUTO_LAYOUT: 'group_auto_layout',
    // 创建编组
    GROUP_CREATE: 'group_create',
    // 画布平移切换
    CANVAS_PAN_BTN: 'canvas_pan_btn',
    // 底部工具栏上传
    TOOLBAR_UPLOAD_BTN: 'toolbar_upload_btn',
    // 新建画板
    NEW_FRAME_BTN: 'new_frame_btn',
    // 文字工具
    TEXT_TOOL_BTN: 'text_tool_btn',
    // 底部生成器入口
    BOTTOM_GENERATOR_ENTRY_CLICK: 'bottom_generator_entry_click',
    // 画布右键菜单点击
    CONTEXT_MENU_CLICK: 'context_menu_click',

    /** ------ Agent行为 ------ */
    // Agent返回按钮离开当前页面
    AGENT_BACK_BTN: 'back_btn',
    // 剧本卡片-展开
    AGENT_SCRIPT_CARD_EXPAND: 'script_card_expand',
    // 剧本卡片-收起
    AGENT_SCRIPT_CARD_COLLAPSE: 'script_card_collapse',
    // 确认进入分镜制作
    AGENT_OUTLINE_CONFIRM_BTN: 'confirm_outline_btn',

    /** ------ 分镜表格页 ------ */
    // 分镜表格页-展示
    STORYBOARD_TABLE_PAGE: 'table_page',
    // 分镜表格页-返回按钮
    STORYBOARD_TABLE_BACK_BTN: 'back_btn',
    // 分镜表格页-去剪辑按钮
    STORYBOARD_TABLE_GO_EDIT_BTN: 'go_edit_btn',
    // 分镜表格页-去画布创作按钮
    STORYBOARD_TABLE_GO_CANVAS_BTN: 'go_canvas_btn',
    // 分镜表格页-展示设置按钮（open 展开面板 / close 收起面板）
    STORYBOARD_TABLE_DISPLAY_SETTING_BTN: 'storyboard_display_setting_btn',
    // 分镜表格页-全展示按钮
    STORYBOARD_TABLE_DISPLAY_ALL_BTN: 'storyboard_display_all_btn',
    // 分镜表格页-单列显隐切换
    STORYBOARD_TABLE_DISPLAY_OPTION_TOGGLE: 'storyboard_display_option_toggle',
    // 分镜未全部产出弹窗-展示
    STORYBOARD_PANEL_UNFINISHED_DIALOG: 'panel_unfinished_dialog',
    // 分镜未全部产出弹窗-返回分镜
    STORYBOARD_PANEL_UNFINISHED_BACK: 'panel_unfinished_back',
    // 分镜未全部产出弹窗-进入编辑器
    STORYBOARD_PANEL_UNFINISHED_ENTER: 'panel_unfinished_enter',
    // 新增分镜
    STORYBOARD_ADD_PANEL_BTN: 'add_panel_btn',
    // 复制分镜
    STORYBOARD_COPY_PANEL_BTN: 'copy_panel_btn',
    // 删除分镜-确认
    STORYBOARD_DELETE_PANEL_CONFIRM: 'delete_panel_confirm',
    // 拖拽分镜排序
    STORYBOARD_DRAG_PANEL_SORT: 'drag_panel_sort',
    // 上传点击
    STORYBOARD_UPLOAD_BTN: 'upload_btn',
    // 去创作点击
    STORYBOARD_GO_CREATE_BTN: 'go_create_btn',
    // 音频-去创作点击
    STORYBOARD_AUDIO_CREATE_BTN: 'audio_create_btn',
    // 点击展开预览弹窗
    STORYBOARD_PREVIEW_DIALOG: 'preview_dialog',
    // 点击关闭预览弹窗
    STORYBOARD_PREVIEW_DIALOG_CLOSE: 'preview_dialog_close',
    // 预览弹窗-左侧分镜切换
    STORYBOARD_PREVIEW_PANEL_SWITCH: 'preview_panel_switch',
    // 预览弹窗-顶部类型切换
    STORYBOARD_PREVIEW_TYPE_SWITCH: 'preview_type_switch',
    // 预览弹窗-底部缩略图切换
    STORYBOARD_PREVIEW_THUMBNAIL_SWITCH: 'preview_thumbnail_switch',
    // 预览弹窗-连播预览按钮点击
    STORYBOARD_PREVIEW_DROPDOWN_BTN: 'storyboard_preview_dropdown_btn',
    // 预览弹窗-连播预览下拉菜单展现
    STORYBOARD_PREVIEW_DROPDOWN_SHOW: 'storyboard_preview_dropdown_show',
    // 预览弹窗-连播预览模式选择
    STORYBOARD_PREVIEW_OPTION_SELECT: 'storyboard_preview_option_select',
    // 预览弹窗-选择等级
    STORYBOARD_PREVIEW_REVIEW_LEVEL_SELECT: 'preview_review_level_select',
    // 预览弹窗-点击批注输入
    STORYBOARD_PREVIEW_COMMENT_INPUT: 'preview_comment_input',
    // 预览弹窗-音频播放/暂停
    STORYBOARD_PREVIEW_AUDIO_PLAY_TOGGLE: 'preview_audio_play_toggle',
    // 预览弹窗-视频播放/暂停
    STORYBOARD_PREVIEW_VIDEO_PLAY_TOGGLE: 'preview_video_play_toggle',
    // 分镜富文本资产选择面板-Tab 切换
    STORYBOARD_RICH_TEXT_ASSET_TAB_SWITCH: 'storyboard_asset_panel_tab',
    // 分镜富文本资产选择面板-展示
    STORYBOARD_RICH_TEXT_ASSET_PANEL_SHOW: 'storyboard_asset_panel_show',
    // 分镜富文本资产选择面板-插入资产
    STORYBOARD_RICH_TEXT_ASSET_INSERT: 'storyboard_asset_insert',
    // 分镜富文本引用资产-hover 预览
    STORYBOARD_RICH_TEXT_ASSET_HOVER_PREVIEW: 'storyboard_asset_hover_preview',
    // 分镜富文本引用资产-替换按钮
    STORYBOARD_RICH_TEXT_ASSET_REPLACE_BTN: 'storyboard_asset_replace_btn',
    // 分镜富文本引用资产-删除按钮
    STORYBOARD_RICH_TEXT_ASSET_DELETE_ALL: 'storyboard_asset_delete_all',
    // 分镜富文本引用资产-删除二次确认
    STORYBOARD_RICH_TEXT_ASSET_DELETE_ALL_CONFIRM: 'storyboard_asset_delete_all_confirm',

    /** ------ 画布创作器行为 ------ */
    // 创作器提交生成
    GENERATOR_SUBMIT: 'generator_generate_btn',
    // 创作器打开配置弹层
    GENERATOR_SETTING_CHANGE: 'gen_setting_change',
    // 创作器添加参考图
    GENERATOR_REFERENCE_IMAGE_ADD: 'reference_image_add_btn',
    // 创作器添加参考视频
    GENERATOR_REFERENCE_VIDEO_ADD: 'reference_video_add_btn',
    // 创作器添加参考音频
    GENERATOR_REFERENCE_AUDIO_ADD: 'reference_audio_add_btn',
    // 创作器删除参考材料
    GENERATOR_REF_MATERIAL_DELETE: 'generator_ref_material_delete',
    // 画面风格弹窗打开
    GENERATOR_STYLE_DIALOG_OPEN: 'style_dialog_open',
    // 画面风格删除
    GENERATOR_STYLE_DELETE: 'img_gen_style_delete',
    // 画面风格选择
    GENERATOR_STYLE_SELECT: 'style_dialog_select',
    // 画面风格确认
    GENERATOR_STYLE_CONFIRM: 'style_dialog_confirm',
    // 积分不足 toast
    GENERATOR_CREDIT_INSUFFICIENT_TOAST: 'credit_insufficient_toast',
    // 画布agent草图积分确认按钮
    CREDIT_CONFIRM_BTN: 'credit_confirm_btn',
    // 创作器引用素材面板展现
    GENERATOR_REF_PANEL_SHOW: 'generator_ref_panel_show',
    // 创作器引用素材面板插入
    GENERATOR_REF_MATERIAL_INSERT: 'generator_ref_material_insert',

    // 付费墙相关
    /** 付费墙 Tooltip CTA 按钮点击 */
    MEMBER_TOOLTIP_CTA: 'member_tooltip_cta',
    /** 画布生成器模型选项点击 */
    GEN_MODEL_SELECT: 'gen_model_select',
    /** 画布模型列表"开通会员"按钮 */
    PAID_MODEL_OPEN_MEMBERSHIP: 'paid_model_open_membership',
    /** 人员管理开通/升级会员按钮 */
    MEMBER_MANAGEMENT_OPEN_MEMBERSHIP: 'member_management_open_membership',
    /** 权益不足卡片曝光 */
    INSUFFICIENT_CREDITS_CARD: 'insufficient_credits_card',
    /** 权益不足卡片按钮点击（开通/升级会员） */
    CARD_OPEN_MEMBERSHIP: 'card_open_membership',
    /** 权益不足卡片充值积分按钮点击 */
    CARD_CREDIT_RECHARGE: 'card_credit_recharge',

    /** ------ 会员等级弹窗行为 ------ */
    // 会员等级弹窗-订阅按钮
    MEMBERSHIP_MODAL_SUBSCRIBE_BTN: 'subscribe_btn',
    // 会员等级弹窗-单独购买积分
    MEMBERSHIP_MODAL_BUY_POINTS_BTN: 'buy_points_separately',
    // 会员等级弹窗-常见问题展开按钮
    MEMBERSHIP_MODAL_FAQ_EXPAND_BTN: 'faq_expand',
    // 二次确认弹窗
    MEMBERSHIP_PAY_CONFIRM_MODAL: 'member_subscription_confirmation_pop',
    // 二次确认弹窗-确认支付
    MEMBERSHIP_PAY_CONFIRM_MODAL_CONFIRM_BTN: 'confirm_payment_btn',
    // 支付弹窗
    MEMBERSHIP_PAY_QRCODE_MODAL: 'qrcode_payment_pop',
    // 支付弹窗-二维码重试
    MEMBERSHIP_PAY_QRCODE_MODAL_RETRY: 'qrcode_retry',
    // 支付弹窗-支付成功
    MEMBERSHIP_PAY_QRCODE_MODAL_PAY_SUCCESS: 'success_pay',
    // 关闭确认弹窗-重新考虑
    MEMBERSHIP_PAY_QRCODE_MODAL_CLOSE_CONFIRM_RECONSIDER: 'close_confirm_reconsider',
    // 关闭确认弹窗-确认支付
    MEMBERSHIP_PAY_QRCODE_MODAL_CLOSE_CONFIRM_EXIT: 'close_confirm_exit',

    /** ------ 积分购买弹窗相关行为 ------ */
    // 积分购买弹窗-展示
    POINT_CREDITS_PURCHASE_POP: 'credits_purchase_pop',
    // 充值套餐-点击
    POINT_PLAN_SELECT: 'plan_select',
    // 二维码重试态曝光
    POINT_QRCODE_RETRY: 'qrcode_retry',
    // 支付成功弹窗曝光
    POINT_SUCCESS_PAY: 'success_pay',

    /** ------ 订阅管理/订单记录页 ------ */
    // 订阅管理/订单记录弹窗展示
    SUBSCRIPTION_MANAGEMENT_POP: 'subscription_management_pop',
    // 订阅管理/订单记录页-非会员点击【去订阅会员】
    SUBSCRIPTION_BTN: 'subscription_btn',

    /** ------ 会员及积分服务协议页 ------ */
    // 协议页展现
    MEMBERSHIP_AGREEMENT: 'membership_subscription_payment_agreement',
} as const;

// agent_type 公共参数
export const AgentType = {
    CANVAS: 'canvas',
    SCRIPT: 'script',
    STORYBOARD: 'storyboard',
} as const;

// page form 公共参数
export const PageForm = {
    HOME: 'home',
    WORKSPACE: 'workspace',
    ASSET: 'asset',
} as const;
